import React, { useEffect, useState } from 'react'
import MainQueSection from './MainQueSection';
import "./product-question.scss"
import { toast } from "react-toastify"
import {  CreateOrUpdateProductQuestionAction  } from "../../redux/actions/product-questions/createOrUpdateProductQue"
import {  GetProductQuestionsAction  } from "../../redux/actions/product-questions/getProductQuestions"
import ConfirmationModal from '../finance-identity/finance-confirmationModal';
import {  ReactComponent as BackArrow  } from "../../../images/back_arrow.svg"
import {  useParams  } from "react-router"
import {  webBaseUrl  } from "../../../config"
import StepButton from '../../common/StepButton';
import ProductClientId from './ProductClientId';
import ProductquestionThankyou from './ProductquestionThankyou';


const ProductQuestions = () => {
  const [questionType, setQuestionType] = useState(1);
  const [disableTypeChange, setDisableTypeChange] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModuleId, setDeleteModuleId] = useState(null);
  const [step, setStep] = useState(1)
  const [questionError, setQuestionError] = useState("")
  const [answerError, setAnswerError] = useState("")
  const [quesNumber, setQuesNumber] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [isCheckBtn, setIsCheckBtn] = useState(null)
  const [clientIdVal, setclientIdVal] = useState(null)
  const [isReqiredId, setIsRequiedId] = useState(false)
  const [page, setPage] = useState(1)

  const [docError, setDocError] = useState(null)
  const [isCheckop, setIsCheckOp] = useState(null)
  const { productId } = useParams()

  const [queIndex, setQueIndex] = useState(0);
  const [questionsValue, setQuestionsValue] = useState(
    {
      id: 0,
      questionId: null,
      draftId: null,
      questionType: null,
      questionText: "",
      answerOptions: [
        {
          optionId: null,
          answerText: "",
          isCorrect: false,
        },
        {
          optionId: null,
          answerText: "",
          isCorrect: true,
        },

      ],

    },
  );


  const { initcreateOrUpdateProductQuestionData, createOrUpdateProductQuestionQueryData } = CreateOrUpdateProductQuestionAction()
  const { getProductQuestionQueryData, initGetProductQuestionData } = GetProductQuestionsAction()


  const handleDeleteModal = (index) => {
    setDeleteModuleId(index);
    setDeleteModal(true);

  };


  useEffect(() => {
    initGetProductQuestionData({
      productId: parseInt(productId),
      page:  page,
        limit: 1
    })
  }, [page])

  console.log(`getProductQuestionQueryData`, getProductQuestionQueryData?.data);

  useEffect(() => {
    if (getProductQuestionQueryData?.data) {
      const getProductdata = getProductQuestionQueryData?.data?.getProductQuestions?.data?.questions;
      console.log("getProductdata", getProductdata)
      if (getProductdata && getProductdata?.length && getProductdata !== null) {
        if (getProductdata.length > queIndex) {
          const answerOption = getProductdata[queIndex]?.options?.length ?
            getProductdata[queIndex]?.options?.map((data, index) => ({
              optionId: data.id,
              answerText: data.option_text,
              isCorrect: data.isCorrect
            }))
            :
            [
              {
                optionId: null,
                answerText: "",
                isCorrect: false,
              },
              {
                optionId: null,
                answerText: "",
                isCorrect: true,
              },
            ]

          console.log("answerOption11", answerOption)
          setQuestionType(getProductdata[queIndex]?.type)
          setQuestionsValue({
            id: getProductdata[queIndex]?.id,
            questionId: getProductdata[queIndex]?.id,
            draftId: getProductdata[queIndex]?.draftId,
            questionType: getProductdata[queIndex]?.type,
            questionText: getProductdata[queIndex]?.question_text,
            answerOptions: answerOption,

          },)
          setDisableTypeChange(true)
        }
        if (getProductdata.length <= queIndex) {
          const newQuestion = {
            id: 0,
            questionId: null,
            draftId: null,
            questionType: null,
            questionText: "",
            answerOptions: [
              {
                optionId: null,
                answerText: "",
                isCorrect: false,
              },
              {
                optionId: null,
                answerText: "",
                isCorrect: true,
              },
            ],
          };
          setQuestionsValue(newQuestion);

          //  setQuestionType(1)
          setDisableTypeChange(false)
        }
      }
      // console.log("getProductdata[queIndex]?.question_text",getProductdata.questions[queIndex],queIndex)
    }

  }, [getProductQuestionQueryData?.data, queIndex])

  console.log("isReqiredId", getProductQuestionQueryData?.data?.getProductQuestions?.data?.isIdentityRequired)

  useEffect(() => {
    if (getProductQuestionQueryData?.data) {
      const isReqiredFlag = getProductQuestionQueryData?.data?.getProductQuestions?.data?.isIdentityRequired;
      if (isReqiredFlag) {
        setclientIdVal("yes")
      } else if (isReqiredFlag === false) {
        setclientIdVal("no")
      } else {
        setclientIdVal(null)
      }
    }

  }, [getProductQuestionQueryData?.data, isReqiredId])



  const nextQuestion = () => {
    if (questionsValue.questionText === "") {
      setQuestionError(`Question  is required!`);
      return; // Prevent going to the next step if the question is empty
    }
    const hasEmptyAnswer = questionsValue.answerOptions.some(option => option.answerText === "");
    if (questionType === 2 && hasEmptyAnswer) {
      setAnswerError("Option is required!");
      return;
    }
    setQuestionError("")
    setQueIndex(queIndex + 1)
    setQuesNumber(quesNumber + 1)
    setIsLoading(false)
  }


  useEffect(() => {
  }, [quesNumber])

  const handleRemoveQuestion = () => {

    if (questionsValue.id === deleteModuleId) {
      setQuestionsValue({

        questionId: null,
        draftId: null,
        questionType: null,
        questionText: "",
        answerOptions: [
          {
            optionId: null,
            answerText: "",
            isCorrect: false,
          },
          {
            optionId: null,
            answerText: "",
            isCorrect: true,
          },
        ],
      })
    }
    setDisableTypeChange(false);
    setDeleteModal(false);
    setDeleteModuleId(null);
  }

  const handleChange = (id, value) => {

    let question = { ...questionsValue };
    console.log("IIII", id, question.id)
    if (question.id === id) {
      question.questionText = value;
    }

    setQuestionsValue(question);
  }

  const handleOptionChange = (id, option_id, value) => {


    let question = { ...questionsValue };

    if (question.id === id) {
      question.answerOptions = question.answerOptions.map((opEl, opInd) => {
        if (opInd === option_id) {
          return {
            ...opEl,
            answerText: value,
          };
        }
        return opEl;
      });
    }
    setQuestionsValue(question);
  }

  const handleOptionRadioChange = (queIndex, quesId, option_id) => {


    let question = { ...questionsValue };

    question.answerOptions = question.answerOptions.map((e, i) => ({
      ...e,
      isCorrect: i === option_id,
    }));



    setQuestionsValue(question);
  }



  const handleSubmit = (e, shouldRedirect = false) => {
    setPage(prevPage => prevPage + 1);  // Increment the page by 1
    const limit = page + 1;
    const getProductdata = getProductQuestionQueryData?.data?.getProductQuestions?.data?.questions;
    const answerOptions = questionsValue.answerOptions.map((op) => ({
      optionId: op.optionId,
      answerText: op.answerText,
      isCorrect: op.isCorrect
    }));

    const questionObj = {
      questionId: getProductdata && getProductdata[queIndex]?.id ? getProductdata[queIndex]?.id : questionsValue.questionId,  // Assuming questionId will be null if it's a new question
      draftId: getProductdata && getProductdata[queIndex]?.draftId ? getProductdata[queIndex]?.draftId : questionsValue.draftId,
      questionType: questionType,
      questionText: questionsValue.questionText,
      answerOptions: questionType === 2 ? answerOptions : []  // Attach the formatted answer options
    };

    if (questionsValue.questionText === "") {
      setQuestionError("Question is required!")
      return;
    }
    const hasEmptyAnswer = questionsValue.answerOptions.some(option => option.answerText === "");
    if (questionType === 2 && hasEmptyAnswer) {
      setAnswerError("Option is required!");
      return;
    }
    // Validate: Duplicate answerText
    const answerTexts = questionsValue.answerOptions.map(option => option.answerText.trim().toLowerCase());
    const hasDuplicateAnswers = new Set(answerTexts).size !== answerTexts.length;
    if (questionType === 2 && hasDuplicateAnswers) {
      // setAnswerError("Duplicate options are not allowed!");
      toast.error("Duplicate options are not allowed!")
      return;
    }

   //  const hasCorrectAnswer = questionsValue.answerOptions.some((option) => option.isCorrect);

   //  if (!hasCorrectAnswer) {
    //   // setAnswerError("correct answer is required!")
    //   toast.warning("Correct answer is deleted!")
    //   return;
   //  }

    setQuestionError("")
    setAnswerError("")
    setIsCheckBtn('next')
    setIsLoading(true)
    if (shouldRedirect) {
      setIsCheckBtn("submit")
    }
    initcreateOrUpdateProductQuestionData({
      productId: parseInt(productId),
      question: questionObj,
      submitClicked:shouldRedirect ? 1 : 0
    }, (data) => {

      if (data) {
        console.log(`data1111`, data);

        toast.success("Question Saved !")
        if (!shouldRedirect) {
          nextQuestion()
        }
        initGetProductQuestionData({
          productId: parseInt(productId),
          page: 1,
          // limit: 5
        })
        if (shouldRedirect) {
          setIsLoading(true)
          setStep(3)
          // window.location.href = webBaseUrl + "/product/lists";
        }
      }
    }, (error) => {
      console.log(`error`, error);
    })

    setPage(limit)
  }


  const handleBack = () => {

    if (queIndex === 0 && quesNumber === 1) {

      setStep(1)
    }
    if (queIndex > 0 && quesNumber > 0) {
      setQueIndex(queIndex - 1)
      setQuesNumber(quesNumber - 1)
    }

    setQuestionError("")
    setAnswerError("")
    setIsLoading(false)

  }

  const handleSetQuestionType = (newType) => {
    setQuestionType(newType)
  };

  const handleClientIdChange = (e) => {

    setclientIdVal(e.target.value)

  }



  const submitClientIdResp = () => {

    if (!clientIdVal) {
      setDocError("Select An option!")
      return
    }

    setDocError(null)
    setIsCheckOp("submit")
    
    initcreateOrUpdateProductQuestionData({
      productId: parseInt(productId),
      isIdentityRequired: clientIdVal === "yes" ? 1 : 2,
      submitClicked:1
    }, (data) => {
      console.log(data)
      toast.success("Question Saved !")
      window.location.href = webBaseUrl + "/product/lists";
      initGetProductQuestionData({
        productId: parseInt(productId),
        page: 1,
         limit:1
      })
    }, (error) => {
      console.log(error)
    })

  }

  const handleNextResponse = () => {
   
    if (!clientIdVal) {
      setDocError("Select An option!")
      return
    }


    setDocError(null)
    setIsCheckOp("next")
    
    initcreateOrUpdateProductQuestionData({
      productId: parseInt(productId),
      isIdentityRequired: clientIdVal === "yes" ? 1 : 2,
      submitClicked: 0
    }, (data) => {
      console.log(data)
      toast.success("Question Saved !")
      initGetProductQuestionData({
        productId: parseInt(productId),
        page: 1,
        limit:1
      })
      setStep(2)
    }, (error) => {
      console.log(error)
    })

  }
  const handleClientBack = () => {
    window.location.href = webBaseUrl + "/product/lists";
  }



  return (
    <>
      {
        step === 1 && (
          <ProductClientId
            handleClientIdChange={handleClientIdChange}
            submitClientIdResp={submitClientIdResp}
            clientIdVal={clientIdVal}
            isLoading={createOrUpdateProductQuestionQueryData?.loading}
            handleNextResponse={handleNextResponse}
            docError={docError}
            isCheckop={isCheckop}
            handleclientback={handleClientBack}
          />
        )
      }
      {
        step === 2 && (
          <div className='ProductQuestionsSec'>
            <div className='backArrowWrapper'>
              <BackArrow className='backBtn' onClick={() => handleBack()} />
            </div>
            <div className='container'>
              <div className='main-area'>
                <div className='product-question-div paddintTop80'>

                  <MainQueSection
                    queIndex={queIndex}
                    quesId={questionsValue.id}
                    question={questionsValue}
                    setQuestionsValue={setQuestionsValue}
                    questionType={questionType}
                    setQuestionType={setQuestionType}
                    handleRemoveQuestion={handleDeleteModal}
                    handleChange={handleChange}
                    handleOptionChange={handleOptionChange}
                    handleOptionRadioChange={handleOptionRadioChange}
                    handleSubmit={handleSubmit}
                    // disabled={disableTypeChange}
                    handleSetQuestionType={handleSetQuestionType}
                    questionError={questionError}
                    quesNumber={quesNumber}
                    answerError={answerError}
                    setAnswerError={setAnswerError}
                  />



                  <div className='add-question-section'>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        marginBottom: "20px"
                      }}
                    >
                      <div className="BtnBottom">
                        <StepButton
                          blue={true}
                          label={"Save & Next"}
                          className="save-btn"
                          type="submit"
                          onClick={() => {
                            // nextQuestion()
                            handleSubmit()
                          }
                          }
                          isLoading={isLoading && isCheckBtn === "next"}
                        />
                      </div>

                      <div className="BtnBottom">
                        <StepButton
                          blue={true}
                          className="save-btn"
                          label={"Submit for review"}
                          type="submit"
                          onClick={(e) => {
                            handleSubmit(e, true)
                          }}
                          isLoading={isLoading && isCheckBtn === "submit"}
                        />

                      </div>
                    </div>

                  </div>

                </div>


              </div>
            </div>

            <ConfirmationModal
              open={deleteModal}
              setOpen={setDeleteModal}
              title="Are you sure?"
              className={"ConfirmationDeleteModal"}
              content="Are you sure you want to delete this Question?"
              onConfirm={() => {
                handleRemoveQuestion();
              }}
              onCancel={() => setDeleteModal(false)}
            />
          </div>
        )
      }
      {
        step === 3 && (<ProductquestionThankyou/>)
      }


    </>
  )
}

export default ProductQuestions